module.exports = __webpack_public_path__ + "img/thelees.b28a9e14.jpg";